import { render } from "./PdfExportOverlay.vue?vue&type=template&id=541b245c&scoped=true"
import script from "./PdfExportOverlay.vue?vue&type=script&lang=js"
export * from "./PdfExportOverlay.vue?vue&type=script&lang=js"

import "./PdfExportOverlay.vue?vue&type=style&index=0&id=541b245c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-541b245c"]])

export default __exports__